import React, { useEffect, useRef, useState } from 'react'
import Spinner from '../Spinner'
import Button from '../Button'

// Liste sonu ekranda göründüğünde sonraki sayfayı otomatik yükler, otomatik yükleme olmazsa buton ile yüklenir
const LoadMore = ({ page, pending, onLoadMore }) => {
    const ref = useRef()
    const [visible, setVisible] = useState(false)
    const onLoadMoreRef = useRef(onLoadMore)
    const loadedFor = useRef()

    onLoadMoreRef.current = onLoadMore

    // Liste uzunluğu ve son kayıt değişmediyse yeni kayıt gelmemiştir
    const contentKey = `${page.content.length}:${page.content[page.content.length - 1]?.id}`

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setVisible(entry.isIntersecting),
            { rootMargin: '200px' }
        )
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])

    useEffect(() => {
        if (!visible) {
            loadedFor.current = undefined
            return
        }
        // Aynı içerik için yalnızca bir kez istek atılır; hata veya boş yanıtta sürekli istek atılmaz
        if (pending || page.last || loadedFor.current === contentKey) return
        // Yeni satırlar eklendiğinde gözlemci henüz güncellenmemiş olabilir, konum tekrar ölçülür
        if (ref.current.getBoundingClientRect().top > window.innerHeight + 200) return
        loadedFor.current = contentKey
        onLoadMoreRef.current()
    }, [visible, pending, page.last, contentKey])

    return (
        <div ref={ref} className='flex justify-center mb-5 dark:text-zinc-100'>
            {
                pending &&
                <Spinner />
            }
            {
                !pending && !page.last &&
                <Button
                    text='Daha fazla yükle'
                    variant='blue'
                    onClick={() => {
                        loadedFor.current = contentKey
                        onLoadMore()
                    }}
                />
            }
            {
                page.last && <label className='text-xs'>Tüm kayıtlara ulaştınız.</label>
            }
        </div>
    )
}

export default LoadMore
